import { addMonths } from 'date-fns';
import { Dispatch, SetStateAction, useState } from 'react';
import { formatMonthYear } from '../../lib/helpers/formatMonthYear/formatMonthYear';
import { IRangeDates } from '../../model/types/IRangeDates';
import { IMonthRangePickerWithOptionsProps } from '../../month-range-picker-with-options';
import styles from '../../month-range-picker-with-options.module.scss';
import { AppRangePicker, DatePickerFormat } from '@fsd/shared/ui/AppDatePicker';

interface IProps {
  setSelectedOption: Dispatch<
    SetStateAction<IMonthRangePickerWithOptionsProps['selectedOption']>
  >;
  setShowOptions: Dispatch<SetStateAction<boolean>>;
  setDates: (dates: IRangeDates) => void;
  selectedOption?: number;
  getOptionsClassnames: (index: number) => string;
}

const MonthRangePickerCustomPeriodOption = ({
  selectedOption,
  setSelectedOption,
  setShowOptions,
  setDates,
  getOptionsClassnames,
}: IProps) => {
  const [optionDates, setOptionDates] = useState<IRangeDates>({
    start: new Date(),
    end: addMonths(new Date(), 1),
  });

  const handleCustomPeriodOptionClick = () => {
    setSelectedOption(2);
  };

  return (
    <div
      className={getOptionsClassnames(2)}
      onClick={handleCustomPeriodOptionClick}
    >
      <div className={styles.optionTitle}>Выбрать свой период</div>
      {optionDates.start && optionDates.end && (
        <>
          <div className={styles.optionDesc}>
            {formatMonthYear(optionDates.start)} -{' '}
            {formatMonthYear(optionDates.end)}
          </div>
        </>
      )}
      {selectedOption === 2 && (
        <div className={styles.optionsCalendar}>
          <div className={styles.hiddenRangePicker}>
            <AppRangePicker
              picker="month"
              format={DatePickerFormat.MONTH}
              open={true}
              getPopupContainer={(trigger) =>
                trigger.parentElement ?? document.body
              }
              onChange={(dates) => {
                if (!dates?.[0] || !dates?.[1]) return;

                const range: IRangeDates = {
                  start: dates[0].toDate(),
                  end: dates[1].toDate(),
                };

                setOptionDates(range);
                setDates(range);
                setShowOptions(false);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MonthRangePickerCustomPeriodOption;
